import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgStarXs = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='M4.23 15.0002C4.16 15.0002 4.09 15.0002 4.02 14.9702C3.78 14.9102 3.58 14.7602 3.46 14.5502C3.34 14.3502 3.3 14.1102 3.36 13.8702L4.26 9.91018L1.31 7.25018C0.950005 6.93018 0.900005 6.35018 1.21 5.97018C1.36 5.78018 1.59 5.66018 1.83 5.64018L5.69 5.31018L7.17 1.57018C7.26 1.34018 7.44 1.15018 7.67 1.06018C7.89 0.970176 8.14 0.970176 8.36 1.06018C8.58 1.16018 8.76 1.34018 8.85001 1.57018L10.33 5.31018L14.19 5.64018C14.55 5.67018 14.85 5.91018 14.97 6.26018C15.09 6.61018 14.99 7.00018 14.71 7.25018L11.76 9.91018L12.66 13.8702C12.77 14.3602 12.48 14.8502 12 14.9702C11.77 15.0302 11.51 14.9902 11.31 14.8602L8.02001 12.7502L4.73 14.8602C4.59 14.9502 4.42 15.0002 4.25 15.0002H4.23ZM2.11 6.63018L5.37 9.57018L4.37 13.9302L8 11.5602L11.62 13.8802L10.63 9.57018L13.89 6.63018L9.61 6.26018L8 2.18018L6.39 6.26018L2.11 6.63018Z' />
  </svg>
);
export default SvgStarXs;
